/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button/Button';
import Grid from '@material-ui/core/Grid';
import {
    object, func, shape, string,
} from 'prop-types';
import CardInsideEditted from './ReviewInsideCard';
import ReviewFrontCard from './ReviewFrontCard';

const styles = (theme) => ({
    container: {
        width: '100%',
    },
    templatesContainer: {
        overflow: 'hidden',
        height: 'calc(95% - 110px)',
        padding: '0px 10px',
        margin: '0 auto',
        maxHeight: '100%',
        overflowY: 'auto',
        [theme.breakpoints.down('xs')]: {
            height: 390,
            display: 'block',
            padding: 0,
            overflow: 'visible',
            margin: '0 auto',
        },
    },
    cardContainer: {
        display: 'inline-block',
        height: '100%',
        width: '100%',
        justifyContent: 'space-around',
        perspective: '1000px',
        transformStyle: 'preserve-3d',
        maxWidth: '70%',
        [theme.breakpoints.down('xs')]: {
            display: 'block',
            height: '90%',
            maxWidth: '100%',

        },
    },
    cardWrapper: {
        display: 'flex',
        transition: '0.9s',
        transformStyle: 'preserve-3d',
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
            display: 'block',
        },
        '& $reviewFront, & $reviewInside, & $reviewFrontHorizontal, & $reviewInsideHorizontal': {
            backfaceVisibility: 'hidden',
            transition: '0.9s',
            transformStyle: ' preserve-3d',
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0,
        },
    },
    reviewCards: {
        display: 'flex',
        justifyContent: 'space-around',
    },
    buttonFront: {
        marginBottom: 20,
        padding: 10,
        background: 'transparent',
        width: 100,
        fontSize: 12,
        color: 'black',
        outline: 'none',
        border: `1px solid ${theme.palette.cgc?.buttonFrontBorder || '#8020BB'}`,
        borderRadius: 3,
        height: 35,
        fontWeight: 'bold',
        textAlign: 'center',
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]: {
            margin: '0 auto',
        },
    },
    buttonReview: {
        padding: 10,
        width: 100,
        marginBottom: 20,
        outline: 'none',
        textAlign: 'center',
        background: theme.palette.cgc?.bgCardFront || '#c4c4c4',
        height: 35,
        borderRadius: 3,
        color: theme.palette.cgc?.white || 'white',
        border: 'none',
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]: {
            margin: '0 auto',
        },
    },
    buttonNavigation: {
        display: 'inline-block',
        height: '100%',
        width: '100%',
        margin: 25,
        [theme.breakpoints.down('xs')]: {
            display: 'flex',
            height: 'auto',
            margin: '40px 0px 0px  0px',
        },
    },
    buttonWrapper: {
        marginTop: 20,
        display: 'flex',
        justifyContent: 'space-around',
    },
    openButton: {
        outline: 'none',
        fontWeight: 600,
        border: 'none',
        borderBottom: `2px solid ${theme.palette.cgc?.openBottomBorder || '#999'}`,
        background: 'transparent',
    },
    addToCartWrapper: {
        position: 'fixed',
        bottom: 10,
        right: 10,
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            right: 0,
            bottom: 0,
        },
    },
    addToCart: {
        width: 180,
        padding: '8px 12px',
        outline: 'none',
        border: 'none',
        marginRight: 15,
        color: theme.palette.cgc?.white || '#fff',
        borderRadius: 4,
        background: theme.palette.cgc?.bgCartButton || '#7737a9',
        '&:hover': {
            background: theme.palette.cgc?.bgCardFront || '#c4c4c4',
            color: theme.palette.cgc?.hoverButtonColor || '#000000',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            borderRadius: 0,
        },
    },
    reviewFront: {
        zIndex: '2',
        transform: 'rotateY(0)',
    },
    reviewInside: {
        transform: 'rotateY(180deg)',
    },
    reviewFrontHorizontal: {
        zIndex: '2',
        transform: 'rotateX(0)',
    },
    reviewInsideHorizontal: {
        transform: 'rotateX(180deg)',
    },
    hover: {
        '& $reviewInside': {
            transform: 'rotateY(0deg)',
        },
        '& $reviewFront': {
            transform: 'rotateY(180deg)',
        },
        '& $reviewInsideHorizontal': {
            transform: 'rotateX(0deg)',
        },
        '& $reviewFrontHorizontal': {
            transform: 'rotateX(180deg)',
        },
    },
});

class ReviewCard extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isFlipped: false,
            view: 'front',
        };
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(face) {
        this.setState((prevState) => ({ isFlipped: !prevState.isFlipped, view: face }));
    }

    renderReviewCard = () => {
        const {
            classes, messageData, cardData,
        } = this.props;
        const { view } = this.state;

        const isHorizontal = cardData?.card_orientation === 'Horizontal';

        return (
            <Grid item sm={10} md={10} xs={12} className={`${classes.cardContainer} ${view === 'inside' ? classes.hover : ''}`}>
                <div className={classes.cardWrapper}>
                    <div className={`${classes.reviewCards} ${isHorizontal ? classes.reviewFrontHorizontal : classes.reviewFront}`}>
                        <ReviewFrontCard isHorizontal={isHorizontal} cardData={cardData} handleClick={this.handleClick} />
                    </div>
                    <div className={`${classes.reviewCards} ${isHorizontal ? classes.reviewInsideHorizontal : classes.reviewInside}`}>
                        <CardInsideEditted isHorizontal={isHorizontal} messageData={messageData} handleClick={this.handleClick} />
                    </div>
                </div>
            </Grid>
        );
    }

    renderButtons = () => {
        const { classes, dataDictionary } = this.props;
        const { view } = this.state;
        return (
            <Grid item sm={2} md={2} xs={12} className={classes.buttonNavigation}>
                <button type="button" className={view === 'front' ? classes.buttonFront : classes.buttonReview} onClick={() => this.handleClick('front')} disabled={view === 'front'}> {dataDictionary?.['Front'] || 'Front'} </button>
                <br />
                <button type="button" className={view === 'inside' ? classes.buttonFront : classes.buttonReview} onClick={() => this.handleClick('inside')} disabled={view === 'inside'}> {dataDictionary?.['Inside'] || 'Inside'} </button>
            </Grid>
        );
    }

    render() {
        const {
            classes, addToCart, dataDictionary,
        } = this.props;
        return (
            <Grid container className={classes.templatesContainer}>
                {this.renderReviewCard()}
                {this.renderButtons()}
                <Grid xs={12} className={classes.addToCartWrapper}>
                    <Button type="submit" className={classes.addToCart} onClick={() => addToCart()}>
                        {dataDictionary?.['Add To Cart'] || 'Add To Cart'}
                    </Button>
                </Grid>
            </Grid>
        );
    }
}
ReviewCard.propTypes = {
    classes: object.isRequired,
    addToCart: func.isRequired,
    messageData: shape({
        text: string,
        style: shape({
            textAlign: string.isRequired,
            color: string.isRequired,
        }).isRequired,
    }).isRequired,
    cardData: shape({
        url: string,
    }).isRequired,
    dataDictionary: object,
};
ReviewCard.defaultProps = {
    dataDictionary: {},
};
export default withStyles(styles)(ReviewCard);
